import React from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import Container from "@mui/material/Container";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import CssBaseline from "@mui/material/CssBaseline";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import SaveIcon from "@mui/icons-material/Save";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Typography from "@mui/material/Typography";
import swal from "sweetalert";
import { Link } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { toast } from "react-toastify";
import * as userApi from "../../api/userApi";
import * as companyApi from "../../api/companyApi";
import { withRouter } from "../common/WithRouter";

class UserDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      profile: {},
      signedInUser: {},
      companies: [],
      errors: {},
      message: "",
      newComany: {
        userId: "",
        companyId: 0,
        admin: 0,
        fno: 0,
        tff: 0,
        yff: 0,
        gk: 0,
      },
      open: false,
      errorsDialog: {},
    };
  }

  async componentDidMount() {
    try {
      const signedInUserName = sessionStorage.getItem("token")
        ? JSON.parse(sessionStorage.getItem("token")).userName
        : "";

      if (signedInUserName) {
        const signedInUser = await userApi.getUser(signedInUserName);
        if (signedInUser) {
          this.setState({ signedInUser: signedInUser[0] });
        }
      }

      const username = this.props.params.username;
      if (username) {
        const profile = await userApi.getUser(username);
        if (profile) this.setState({ profile: profile[0] });
      }

      this.getCompanies();
    } catch (error) {
      console.log("Error in componentDidMount", error);
    }
  }

  getCompanies = async () => {
    const companies = await companyApi.getCompanies();
    if (companies) {
      companies.sort((a, b) => {
        if (a.companyName < b.companyName) return -1;
        if (a.companyName > b.companyName) return 1;
        return 0;
      });
      this.setState({ companies });
    }
  };

  onChange = (e) => {
    try {
      const name = e.target.name;
      const value = e.target.value;

      const errors = { ...this.state.errors };
      errors[name] = "";
      this.setState({ errors });

      const profile = { ...this.state.profile };
      profile[name] = value;
      this.setState({ profile });
    } catch (error) {
      console.log("Error in onChange", error);
    }
  };

  handleRadioButtonChange = () => {
    try {
      const profile = { ...this.state.profile };
      profile.activeUser = !profile.activeUser;
      this.setState({ profile });
    } catch (error) {
      console.log("Error in handleRadioButtonChange", error);
    }
  };

  handleCheckboxChange = (e) => {
    try {
      const profile = { ...this.state.profile };
      if (e.target.checked) {
        profile[e.target.name] = 1;
      } else {
        profile[e.target.name] = 0;
      }
      this.setState({ profile });
    } catch (error) {
      console.log("Error in handleCheckboxChange", error);
    }
  };

  onSave = async (event) => {
    try {
      event.preventDefault();
      if (!this.formIsValid()) return;

      const status = await userApi.updateUserAdimn(this.state.profile);
      if (
        status === "Does not meet requirements for passwords." ||
        status === "Does not meet Admin requirements for passwords."
      ) {
        const errors = {
          newPassword:
            "Passordet må være minst 10 tegn (16 tegn for Admin). Må innholde minst én liten bokstav, én stor bokstav, ett tall og ett spesialtegn.",
        };
        this.setState({ errors });
        return;
      }
      if (status === "Password previously used.") {
        const errors = {
          newPassword:
            "Passordet må ikke være samme som de 13 forrige. Velg et nytt passord",
        };
        this.setState({ errors });
        return;
      }
      if (status === "No Role(s) Assigned!") {
        const errors = {
          noRoles: "Ingen roller ble tilegnet brukerkontoen. Velg minst en rolle.",
        };
        this.setState({ errors });
        return;
      }
      if (status) {
        toast.success("Profil lagret.");
      } else {
        toast.error("Det skjedde en feil...");
      }
    } catch (error) {
      throw error;
    }
  };

  formIsValid = () => {
    const { companyId, newPassword, repeatPassord } = this.state.profile;
    const errors = {};
    if (!companyId) errors.companyId = "Velg bedrift";
    if (newPassword && !repeatPassord) {
      errors.repeatPassord = "   ";
    } else if (repeatPassord && !newPassword) {
      errors.newPassword = "   ";
    } else if (newPassword && repeatPassord && newPassword !== repeatPassord) {
      errors.repeatPassord = "Passord og Gjentatt passord må være samme";
    }

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleClick = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleDeleteCompany = async (company) => {
    swal({
      title: "Slette bedrift?",
      text: company.companyName,
      icon: "warning",
      dangerMode: true,
      buttons: ["Avbryt", "OK"],
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const { profile } = this.state;
          company.userId = profile.userId;
          const response = await companyApi.deleteNewCompany(company);
          console.log(response);
          if (response) {
            swal("Bedrift er slettet!", {
              icon: "success",
            });
            let profile = { ...this.state.profile };
            if (Array.isArray(profile.availableCompanies) && profile.availableCompanies.length) {
              let index = profile.availableCompanies.indexOf(company);
              if (index !== -1) {
                profile.availableCompanies.splice(index, 1);
                await this.setState({ profile });
              }
            }
          } else {
            swal("Det oppsto en feil...", {
              icon: "error",
            });
          }
        } catch (error) {
          console.log(error);
        }
      }
    });
  };

  onChangeDialog = (e) => {
    try {
      const name = e.target.name;
      const value = e.target.value;
      const newComany = { ...this.state.newComany };
      newComany[name] = value;
      this.setState({ newComany });
    } catch (error) {
      console.log("Error in onChange", error);
    }
  };

  handleSaveCompany = async (event) => {
    try {
      event.preventDefault();
      if (!this.formIsValidDialog()) return;
      const { profile, newComany } = this.state;
      newComany.userId = profile.userId;
      const response = await companyApi.createNewCompany(newComany);
      if (response) {
        toast.success("Bedrift lagret.");
        this.setState(
          {
            open: false,
            newComany: {},
          }
        );
        let profile = { ...this.state.profile };
        if (Array.isArray(profile.availableCompanies) && profile.availableCompanies.length) {
          profile.availableCompanies.push(response);
          await this.setState({ profile });
        }
        // const profile = await userApi.getUser(profile.userName);
        // if(profile) this.setState ({profile});    
      } else {
        toast.error("Det skjedd noe feil...");
      }
    } catch (error) {
      console.log(error);
    }
  };

  formIsValidDialog = () => {
    const { newComany } = this.state;
    const errorsDialog = {};

    if (!newComany.companyId || newComany.companyId === 0) {
      errorsDialog.companyId = "Må velge en bedrift";
    }
    this.setState({ errorsDialog });
    return Object.keys(errorsDialog).length === 0;
  };


  handleCheckboxChangeDialog = (e) => {
    try {
      const newComany = { ...this.state.newComany };
      if (e.target.value === "0") {
        newComany[e.target.name] = 1;
      } else {
        newComany[e.target.name] = 0;
      }
      this.setState({ newComany });
    } catch (error) {
      console.log("Error in handleCheckboxChange", error);
    }
  };

  handleClickGA = async () => {
    const profile = { ...this.state.profile };
    swal({
      title: `Tilbakestille Google Authenticator for bruker "${profile.userName}" ?`,
      //text: profile.userName + " ?",
      icon: "warning",
      dangerMode: true,
      buttons: ["Avbryt", "OK"],
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const userId = {};
          userId.userId = profile.userId;
          const response = await userApi.remove2FA(userId);
          console.log(response);
          if (response) {
            swal("Fullført!", {
              icon: "success",
            });
            profile.mfaActivated = !profile.mfaActivated;
            this.setState({ profile })
          } else {
            swal("Det oppsto en feil...", {
              icon: "error",
            });
          }
        } catch (error) {
          console.log(error);
        }
      }
    });
  };

  render() {
    const layout = {
      width: "100%",
      paddingTop: 80,
    };

    const paper = {
      paddingLeft: 30,
      paddingTop: 20,
    };

    const gridPaddingTop = {
      paddingTop: 20,
    };

    const link = {
      textDecoration: "none",
      color: "#673ab7",
    };

    const button = {
      padding: "0px",
    };

    const enable =
      this.state.profile.mfaActivated &&
      this.state.profile.userName !== this.state.signedInUser.userName;

    return (
      <Container maxWidth="lg">
        <form onSubmit={this.onSave}>
          <main style={layout}>
            <Paper style={paper}>
              <React.Fragment>
                <CssBaseline />
                <h1>Bruker informasjon</h1>
                {enable && (
                  <Grid>
                    <Button
                      color="secondary"
                      style={button}
                      onClick={this.handleClickGA}
                    >
                      Klikke her for å tilbakestille Google Authenticator for bruker
                    </Button>
                  </Grid>
                )}
                <Grid container spacing={3}>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Grid style={gridPaddingTop}>
                      <TextField
                        variant="standard"
                        name="userName"
                        label="Brukernavn"
                        value={this.state.profile.userName || ""}
                        fullWidth
                        disabled
                      />
                    </Grid>
                    <Grid style={gridPaddingTop}>
                      <FormControl variant="standard" required fullWidth>
                        <InputLabel>Bedrift</InputLabel>
                        <Select
                          name="companyId"
                          label="Bedrift"
                          value={this.state.profile.companyId || ""}
                          onChange={this.onChange}
                          error={Boolean(this.state.errors.companyId)}
                                                helpertext={this.state.errors.companyId || ""}
                        >
                          {this.state.companies.map((company, index) => (
                            <MenuItem key={index} value={company.companyId}>
                              {company.companyName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    {this.state.signedInUser.admin === 1 && (
                      <React.Fragment>
                        <Grid style={gridPaddingTop}>
                          <Link
                            href="#"
                            style={link}
                            onClick={this.handleClick}
                          >
                            Klikke her for å legge inn flere bedrifter
                          </Link>
                        </Grid>
                        <Dialog
                          open={this.state.open}
                          onClose={this.handleClose}
                          fullWidth
                        >
                          <DialogTitle>Bedrifter:</DialogTitle>
                          <DialogContent>
                            {this.state.profile.availableCompanies &&
                              this.state.profile.availableCompanies.map(
                                (company) => (
                                  <Grid container>
                                    <Grid item lg={10}>
                                      <Typography>{company.companyName}</Typography>
                                    </Grid>
                                    <Grid item lg={2}>
                                      <Button
                                        style={{
                                          textDecoration: "none",
                                          color: "#B22222",
                                        }}
                                        onClick={() =>
                                          this.handleDeleteCompany(company)
                                        }
                                      >
                                        <DeleteForeverIcon />
                                      </Button>
                                    </Grid>
                                  </Grid>
                                )
                              )}
                          </DialogContent>
                          <DialogTitle>Legger til ny bedrift:</DialogTitle>
                          <DialogContent>
                            <FormControl required fullWidth>
                              <InputLabel>Velg bedrift</InputLabel>
                              <Select
                                name="companyId"
                                label="Bedrift"
                                value={this.state.newComany.companyId || ""}
                                onChange={this.onChangeDialog}
                                error={Boolean(this.state.errorsDialog.companyId)}
                              >
                                {this.state.companies.map((company) => (
                                  <MenuItem
                                    key={company.companyId}
                                    value={company.companyId}
                                  >
                                    {company.companyName}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </DialogContent>
                          <DialogTitle>Tilganger:</DialogTitle>
                          <DialogContent>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  name="admin"
                                  value={this.state.newComany.admin}
                                  checked={this.state.newComany.admin === 1}
                                  onChange={this.handleCheckboxChangeDialog}
                                  color="primary"
                                />
                              }
                              label="Admin"
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  name="fno"
                                  value={this.state.newComany.fno}
                                  checked={this.state.newComany.fno === 1}
                                  onChange={this.handleCheckboxChangeDialog}
                                  color="primary"
                                />
                              }
                              label="FNO"
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  name="tff"
                                  value={this.state.newComany.tff}
                                  checked={this.state.newComany.tff === 1}
                                  onChange={this.handleCheckboxChangeDialog}
                                  color="primary"
                                />
                              }
                              label="TFF"
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  name="yff"
                                  value={this.state.newComany.yff}
                                  checked={this.state.newComany.yff === 1}
                                  onChange={this.handleCheckboxChangeDialog}
                                  color="primary"
                                />
                              }
                              label="YFF"
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  name="gk"
                                  value={this.state.newComany.gk}
                                  checked={this.state.newComany.gk === 1}
                                  onChange={this.handleCheckboxChangeDialog}
                                  color="primary"
                                />
                              }
                              label="GK"
                            />
                          </DialogContent>
                          <DialogActions>
                            <Button onClick={this.handleClose} color="primary">
                              Avbryt
                            </Button>
                            <Button
                              onClick={this.handleSaveCompany}
                              color="primary"
                            >
                              Lagre
                            </Button>
                          </DialogActions>
                        </Dialog>
                      </React.Fragment>
                    )}
                    <Grid style={gridPaddingTop}>
                      <TextField
                        variant="standard"
                        name="fullName"
                        label="Fullt navn"
                        autoComplete="off"
                        value={this.state.profile.fullName || ""}
                        onChange={this.onChange}
                        fullWidth
                      />
                    </Grid>
                    <Grid style={gridPaddingTop}>
                      <TextField
                        variant="standard"
                        name="userEmail"
                        label="E-post"
                        value={this.state.profile.userEmail || ""}
                        fullWidth
                        disabled
                      />
                    </Grid>
                    <Grid style={gridPaddingTop}>
                      <h3>Endre passord</h3>
                      <TextField
                        variant="standard"
                        name="newPassword"
                        label="Passord"
                        autoComplete="new-password"
                        type="password"
                        value={this.state.profile.newPassword || ""}
                        onChange={this.onChange}
                        fullWidth
                        error={Boolean(this.state.errors.newPassword)}
                        helpertext={this.state.errors.newPassword || ""}
                      />
                    </Grid>
                    <Typography style={{ color: "red" }}>
                      {this.state.errors.newPassword}
                    </Typography>
                    <Grid style={gridPaddingTop}>
                      <TextField
                        variant="standard"
                        name="repeatPassord"
                        label="Gjenta passord"
                        type="password"
                        autoComplete="new-password"
                        value={this.state.profile.repeatPassord || ""}
                        onChange={this.onChange}
                        fullWidth
                        error={Boolean(this.state.errors.repeatPassord)}
                        helpertext={this.state.errors.repeatPassord || ""}

                      />
                      <Typography style={{ color: "red" }}>
                        {this.state.errors.repeatPassord}
                      </Typography>
                    </Grid>
                    <Grid style={{ paddingTop: 30, marginBottom: 25 }}>
                      <Button
                        startIcon={<SaveIcon />}
                        type="submit"
                        variant="contained"
                        color="primary"
                      >
                        Lagre
                      </Button>
                    </Grid>
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <h4>Tilganger</h4>
                    <Typography style={{ color: "red" }}>
                      {this.state.errors.noRoles}
                    </Typography>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="admin"
                          value={this.state.profile.admin}
                          checked={this.state.profile.admin === 1}
                          onChange={this.handleCheckboxChange}
                          color="primary"
                          disabled={this.state.signedInUser.admin === 0}
                        />
                      }
                      label="Admin"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="fno"
                          value={this.state.profile.fno}
                          checked={this.state.profile.fno === 1}
                          onChange={this.handleCheckboxChange}
                          color="primary"
                          disabled={this.state.signedInUser.admin === 0}
                        />
                      }
                      label="FNO"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="tff"
                          value={this.state.profile.tff}
                          checked={this.state.profile.tff === 1}
                          onChange={this.handleCheckboxChange}
                          color="primary"
                        />
                      }
                      label="TFF"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="yff"
                          value={this.state.profile.yff}
                          checked={this.state.profile.yff === 1}
                          onChange={this.handleCheckboxChange}
                          color="primary"
                        />
                      }
                      label="YFF"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="gk"
                          value={this.state.profile.gk}
                          checked={this.state.profile.gk === 1}
                          onChange={this.handleCheckboxChange}
                          color="primary"
                        />
                      }
                      label="GK"
                    />
                    <h4 style={gridPaddingTop}>Status</h4>
                    <RadioGroup row>
                      <FormControlLabel
                        control={<Radio color="primary" />}
                        checked={this.state.profile.activeUser === true}
                        onChange={this.handleRadioButtonChange}
                        label="Aktiv"
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        control={<Radio color="primary" />}
                        checked={this.state.profile.activeUser === false}
                        onChange={this.handleRadioButtonChange}
                        label="Inaktiv"
                        labelPlacement="end"
                      />
                    </RadioGroup>
                  </Grid>
                </Grid>
              </React.Fragment>
            </Paper>
          </main>
        </form>
      </Container>
    );
  }
}

export default withRouter(UserDetail);
